import { useState } from "react";
import _ from "lodash";
import * as orderMatrixUtils from "../../../utils/orderMatrix";

let timeout;
export const useMatrixDataState = ({
  colors,
  sizesByLength,
  initialData,
  onUpdate,
  id,
  order,
}) => {
  const onSave = (setData, newData) => {
    setData(newData);
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      onUpdate({
        order: order.doc,
        product: { id, data: newData },
        onSuccess: () => {},
      });
    }, 200);
  };

  const [data, setData] = useState(null);
  if (data === null && !!initialData) {
    setData(initialData);
  }

  const valueForSizeAndColor = ({ length, color, size }) => {
    if (_.isNil(data)) {
      return 0;
    }

    if (_.isNil(data[length])) {
      return 0;
    }

    if (_.isNil(data[length][color])) {
      return 0;
    }

    if (_.isNil(data[length][color][size])) {
      return 0;
    }

    return data[length][color][size];
  };

  const incrementForColor = ({ length, color }) => {
    const newData = orderMatrixUtils.incrementsTheEntriesForColorByOne({
      data,
      color,
      length,
      sizesByLength,
    });
    onSave(setData, newData, onUpdate, order, id, data);
  };

  const decrementForColor = ({ length, color }) => {
    const newData = orderMatrixUtils.decrementsTheEntriesForColorByOne({
      data,
      color,
      length,
      sizesByLength,
    });
    onSave(setData, newData, onUpdate, order, id, data);
  };

  const incrementForSize = ({ length, size }) => {
    const newData = orderMatrixUtils.incrementsTheEntriesForSizeByOne({
      data,
      size,
      length,
      colors,
    });
    onSave(setData, newData, onUpdate, order, id, data);
  };

  const decrementForSize = ({ length, size }) => {
    const newData = orderMatrixUtils.decrementsTheEntriesForSizeByOne({
      data,
      size,
      length,
      colors,
    });
    onSave(setData, newData, onUpdate, order, id, data);
  };

  const updateValueForColorAndSize = ({ length, color, size, value }) => {
    const toAdd = { ...data };
    const colorCode = color;

    if (data[length] && data[length][colorCode]) {
      toAdd[length][colorCode] = { ...data[length][colorCode], [size]: value };
    } else {
      if (!toAdd[length]) {
        toAdd[length] = {};
      }
      if (!toAdd[length][colorCode]) {
        toAdd[length][colorCode] = {};
      }
      toAdd[length][colorCode][size] = value;
    }

    onSave(setData, toAdd, onUpdate, order, id, data);
  };

  return {
    data,
    decrementForColor,
    decrementForSize,
    incrementForColor,
    incrementForSize,
    valueForSizeAndColor,
    updateValueForColorAndSize,
  };
};

export default useMatrixDataState;
